import React, { useContext, useMemo, useState } from 'react';
import YouTube from 'react-youtube';
import styled from 'styled-components/macro';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import { getFields } from '@mirinae/lessons/modules/libs/elementLib';
import Element from '@mirinae/lessons/components/lesson/elements/Element';

const Wrapper = styled(Element)`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    // z-index: 9999;
`;

const getSeconds = (hours, minutes, seconds) => {
    const [ihours, iminutes, iseconds] = [
        parseInt(hours, 10),
        parseInt(minutes, 10),
        parseInt(seconds, 10),
    ];

    return (ihours * 60 * 60) + (iminutes * 60) + iseconds;
};

const VideoClip = ({ element }) => {
    const { startHour, startMinute, startSecond, length, url } = getFields(
        element,
        'startHour',
        'startMinute',
        'startSecond',
        'length',
        'url',
    );

    const player = useContext(PlayerContext);
    const [video, setVideo] = useState(null);
    const startSeconds = getSeconds(startHour, startMinute, startSecond);
    const endSeconds = useMemo(() => startSeconds + parseInt(length, 10), [
        startHour, 
        startMinute, 
        startSecond,
        length,
    ]);
    const [watched, setWatched] = useState(false);

    // YouTube's embed API doesn't provide a way to hook into
    // playtime updates, so you have to do it manually. Here
    // we just use a basic interval to poll offset time with
    // getCurrentTime();
    const [pollInterval, setPollInterval] = useState(null);

    const inputUrl = new URL(url);
    const videoId = inputUrl.searchParams.get('v');

    const complete = () => {
        setWatched(true);
        video.pauseVideo();
        player.postEvent({ action: 'complete' }, element);
    };

    const onReady = (event) => {
        setVideo(event.target);
    };

    const onPlay = () => {
        pollPlayTime();
        const interval = setInterval(() => pollPlayTime(), 100);
        setPollInterval(interval);
    };

    const onStop = () => {
        if (pollInterval != null) {
            clearInterval(pollInterval);
        }
    };

    const pollPlayTime = () => {
        const playbackSeconds = video.getCurrentTime();
        if (playbackSeconds != null && playbackSeconds >= endSeconds && !watched) {
            complete();
        }
    };

    // const replay = () => {
    //     setWatched(false);
    //     setPollInterval(null);
    //     video.seekTo(startSeconds);
    //     video.playVideo();
    // };

    const videoOptions = {
        height: (element.geomElement || element).geom.height, // 213,
        width: (element.geomElement || element).geom.width, // 379,
        playerVars: { start: startSeconds },
    };

    return (
        <Wrapper element={element}>
            <YouTube
                videoId={videoId}
                onReady={onReady}
                onPlay={onPlay}
                onPause={onStop}
                onEnd={onStop}
                opts={videoOptions}
            />
        </Wrapper>
    );
};

export default VideoClip;
